import { render, staticRenderFns } from "./tableNvgongjiashu.vue?vue&type=template&id=1bf1ecab"
import script from "./tableNvgongjiashu.vue?vue&type=script&lang=js"
export * from "./tableNvgongjiashu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports